import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
export default class ClassifiedsHeroCarousel extends Component {
  index = 0;
  view() {
    const images = this.attrs.images || [];
    const alt = this.attrs.alt || '';
    if (!images.length) return null;
    const i = Math.max(0, Math.min(this.index, images.length - 1));
    return m("div", {
      className: "ClassifiedsHeroCarousel"
    }, m("div", {
      className: "ClassifiedsHeroCarousel-frame"
    }, m("picture", null, m("img", {
      src: images[i],
      alt: alt,
      loading: "lazy",
      decoding: "async"
    })), images.length > 1 && m('[', null, m("button", {
      type: "button",
      className: "ClassifiedsHeroCarousel-nav ClassifiedsHeroCarousel-nav--prev",
      onclick: e => {
        e.preventDefault();
        this.index = (i - 1 + images.length) % images.length;
      },
      "aria-label": "Previous"
    }, m("i", {
      className: "fas fa-chevron-left",
      "aria-hidden": "true"
    })), m("button", {
      type: "button",
      className: "ClassifiedsHeroCarousel-nav ClassifiedsHeroCarousel-nav--next",
      onclick: e => {
        e.preventDefault();
        this.index = (i + 1) % images.length;
      },
      "aria-label": "Next"
    }, m("i", {
      className: "fas fa-chevron-right",
      "aria-hidden": "true"
    })), m("ul", {
      className: "ClassifiedsHeroCarousel-bullets",
      "aria-hidden": "true"
    }, images.map((_, idx) => m("li", {
      key: idx,
      className: classList('ClassifiedsHeroCarousel-bullet', idx === i && 'is-active'),
      onclick: () => {
        this.index = idx;
      }
    }))), m("span", {
      className: "ClassifiedsHeroCarousel-counter"
    }, i + 1, " / ", images.length))), images.length > 1 && m("div", {
      className: "ClassifiedsHeroCarousel-thumbs"
    }, images.map((url, idx) => m("button", {
      key: url,
      type: "button",
      className: classList('ClassifiedsHeroCarousel-thumb', idx === i && 'is-active'),
      onclick: e => {
        e.preventDefault();
        this.index = idx;
      }
    }, m("img", {
      src: url,
      alt: "",
      loading: "lazy"
    })))));
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/ClassifiedsHeroCarousel', ClassifiedsHeroCarousel);